// extracted by mini-css-extract-plugin
export default {"selectOption":"UserSearch-UserSearch__selectOption--PHcIh","labelContainer":"UserSearch-UserSearch__labelContainer--GIg3a"};